import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthSidebarComponent } from "./components/sidebar/auth-sidebar.component";
import { AuthNavbarComponent } from "./components/navbar/auth-navbar.component";
import { AuthLogoComponent } from "./components/logo/auth-logo.component";
import { RouterOutlet } from '@angular/router';


@Component({
  selector: 'app-auth-layout',
  imports: [CommonModule, AuthSidebarComponent, AuthNavbarComponent, AuthLogoComponent, RouterOutlet,],
  templateUrl: './auth-layout.component.html',
  styleUrl: './auth-layout.component.scss',
})
export class AuthLayoutComponent { }

